import { useState, useEffect } from 'react';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from '../firebase';

export function useAuth() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Set up auth state listener
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      setLoading(false);
    });

    // Force token refresh every 55 minutes (before the 1 hour expiration)
    const tokenRefreshInterval = setInterval(() => {
      if (auth.currentUser) {
        auth.currentUser.getIdToken(true);
      }
    }, 55 * 60 * 1000);

    // Cleanup subscription
    return () => {
      unsubscribe();
      clearInterval(tokenRefreshInterval);
    };
  }, []);

  // Add debug log for logout
  const logout = async () => {
    try {
      await signOut(auth);
      console.log('Auth Debug: Logout successful');
      window.location.href = '/';
    } catch (error) {
      console.error('Logout failed:', error);
      console.log('Auth Debug: Logout failed');
    }
  };

  return {
    user,
    isLoading: loading,
    isAuthenticated: !!user,
    logout
  };
} 